export const sellerReportFrequentlyAskedQuestions = [
  {
    title: "How quickly will I receive the Seller Intelligence Report after purchasing?",
    content: "The report will be delivered within 2 business days after your purchase."
  },
  {
    title: "How do I purchase a Seller Intelligence Report?",
    content: "Search for a seller's name and click on the 'Seller Intelligence Report' to purchase the report securely."
  },
  {
    title: "Is there a limit to the number of Seller Intelligence Reports I can purchase?",
    content: "No, there is no limit to the number of reports you can purchase."
  },
  {
    title: "Can I use the Seller Intelligence Report for competitor analysis and market research?",
    content: "Absolutely! The report provides valuable insights into a seller's business, metrics, and product listings, enabling you to make data-driven decisions and stay ahead of the competition."
  },
  {
    title: "Do your subscription plans include free reports?",
    content: "Yes, our Pro Tier subscription plan includes 1 free report per month, while our Enterprise Tier subscription plan includes 5 free reports per month."
  },
  {
    title: "Can I export the data from the Seller Intelligence Report?",
    content: "Yes, the Seller Intelligence Report is sent in Excel format, allowing you to easily export and use the data for further research and analysis."
  }
]

